var _defs, _path, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPasswordDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_5_1",
    "data-name": "Component 5 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 460,
    height: 594,
    viewBox: "0 0 460 594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    d: "M10,0H460a0,0,0,0,1,0,0V594a0,0,0,0,1,0,0H10A10,10,0,0,1,0,584V10A10,10,0,0,1,10,0Z",
    transform: "translate(240 95)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 47"
  }, /*#__PURE__*/React.createElement("image", {
    width: 300,
    height: 47,
    xlinkHref: "data:image/png;base64,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"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    d: "M10,0H460a0,0,0,0,1,0,0V594a0,0,0,0,1,0,0H10A10,10,0,0,1,0,584V10A10,10,0,0,1,10,0Z",
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(-240 -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registration",
    transform: "translate(-45.5 255.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M180.5,0A180.5,180.5,0,1,1,0,180.5,180.5,180.5,0,0,1,180.5,0Z",
    transform: "translate(335 -38.736)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2494_",
    d: "M204.407,142.135c5.637-3.382,11.274-6.2,16.348-10.147,30.44,24.24,48.479,62.572,47.915,100.9a9,9,0,0,1-7.328,8.456,83.224,83.224,0,0,1-46.788-7.328,84.514,84.514,0,0,1-46.224-54.68c3.382-7.892,9.019-15.22,15.22-21.985-.564,23.112,12.965,45.661,33.259,57.5,10.147,5.637,21.421,9.019,32.7,9.019C247.813,191.741,230.338,161.3,204.407,142.135ZM182.423,40.667C200.461,16.427,232.029,2.9,261.906,7.408c3.382,1.127,6.765,4.51,6.765,8.456.564,40.024-19.166,79.483-50.734,103.159-11.274,9.583-25.931,14.656-36.641,24.24-16.348,14.093-28.749,34.386-32.132,55.807-2.819,16.911-1.691,33.823-1.691,50.734,0,4.51-3.946,7.892-8.456,8.456a9.174,9.174,0,0,1-10.147-9.019c-.564-21.985,2.255-45.1-6.2-66.518-.564-12.4,0-24.8,0-37.2,5.637,7.892,11.274,16.348,14.656,25.931a138.318,138.318,0,0,1,27.622-39.46V89.71A87.975,87.975,0,0,1,182.423,40.667ZM7.108,15.3c0-3.946,3.382-7.892,7.328-7.892A86.793,86.793,0,0,1,68.553,18.682c25.931,15.22,42.842,45.1,41.715,75.537v63.136c.564,25.931-12.4,51.861-32.7,67.645a86.057,86.057,0,0,1-56.935,18.039c-3.946,0-9.019,0-11.274-3.382-2.819-5.073-1.691-10.147-1.691-14.093C9.363,189.487,27.4,155.1,55.024,131.988c5.637,3.382,11.274,7.328,16.911,10.147-26.494,18.6-43.406,49.607-45.661,81.738,27.622,0,54.116-18.6,62.572-45.1,4.51-11.838,3.382-24.8,3.946-37.2C84.9,134.243,74.754,130.3,65.734,124.1,29.657,100.42,6.545,58.142,7.108,15.3ZM132.252,120.714c4.51-3.946,11.838-1.691,14.093,3.946,2.819,5.637-2.819,13.529-9.019,12.4C129.434,137.061,125.488,125.224,132.252,120.714Zm-.564-43.406c9.019-4.51,20.857,2.819,21.421,12.965.564,7.892-6.2,15.784-14.093,16.348-8.456,1.127-15.784-6.2-16.348-14.657C122.105,85.764,126.051,80.127,131.689,77.308Zm2.819-31c6.765-3.382,15.22,5.073,11.838,11.838-2.255,6.765-11.838,7.892-15.784,2.255A9.424,9.424,0,0,1,134.507,46.3ZM188.06,67.161c-6.765,16.348-3.382,34.386-4.51,51.3,11.838-6.765,23.112-13.529,32.7-23.112a114.045,114.045,0,0,0,33.823-71.028C223.01,24.319,197.643,42.358,188.06,67.161ZM26.274,24.883A116.629,116.629,0,0,0,48.259,83.509C59.533,99.293,75.881,110,92.229,119.023V90.837a64.012,64.012,0,0,0-18.6-45.1A64.557,64.557,0,0,0,26.274,24.883Z",
    transform: "translate(379.295 10.205)",
    fill: "#cecece",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(488.488 76.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 138.904,
    height: 262.051,
    transform: "translate(10.774 18.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1257.427,641.057h-129.6a14.963,14.963,0,0,1-14.946-14.946V360.118a14.963,14.963,0,0,1,14.946-14.946h129.6a14.963,14.963,0,0,1,14.946,14.946V626.111A14.963,14.963,0,0,1,1257.427,641.057Zm-129.6-295.49a14.568,14.568,0,0,0-14.551,14.551V626.111a14.568,14.568,0,0,0,14.551,14.551h129.6a14.568,14.568,0,0,0,14.551-14.551V360.118a14.568,14.568,0,0,0-14.551-14.551Z",
    transform: "translate(-1112.882 -345.172)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M1459.945,394.534h-38.279a.2.2,0,0,1,0-.395h38.279a.2.2,0,1,1,0,.395Z",
    transform: "translate(-1360.58 -384.477)",
    fill: "#363e44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(30.011 159.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 16.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1357.371,1263.5l-80.614.248a11.741,11.741,0,0,1-.072-23.482l80.614-.248a11.741,11.741,0,0,1,.072,23.482Z",
    transform: "translate(-1264.98 -1240.016)",
    fill: "#554494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(15.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1345.5,1162.931l.011,3.535-2.067.006-.031-10.033,3.914-.012a4.534,4.534,0,0,1,1.99.407,3.046,3.046,0,0,1,1.323,1.171,3.276,3.276,0,0,1,.467,1.732,2.88,2.88,0,0,1-1,2.329,4.206,4.206,0,0,1-2.792.86Zm-.005-1.674,1.847-.006a1.817,1.817,0,0,0,1.25-.39,1.4,1.4,0,0,0,.427-1.1,1.656,1.656,0,0,0-.438-1.191,1.621,1.621,0,0,0-1.2-.465l-1.9.006Z",
    transform: "translate(-1343.415 -1156.144)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1385.7,1164.254l-3.625.011-.683,2.069-2.2.007,3.7-10.045,1.916-.006,3.786,10.021-2.2.007Zm-3.071-1.665,2.508-.008-1.273-3.752Z",
    transform: "translate(-1372.133 -1156.035)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1435.057,1163a1.061,1.061,0,0,0-.416-.9,5.426,5.426,0,0,0-1.491-.657,10.524,10.524,0,0,1-1.7-.68,2.78,2.78,0,0,1-1.716-2.482,2.423,2.423,0,0,1,.454-1.452,2.992,2.992,0,0,1,1.313-1,4.955,4.955,0,0,1,1.924-.364,4.512,4.512,0,0,1,1.917.384,3.05,3.05,0,0,1,1.309,1.095,2.876,2.876,0,0,1,.47,1.611l-2.067.006a1.352,1.352,0,0,0-.437-1.07,1.783,1.783,0,0,0-1.221-.379,1.9,1.9,0,0,0-1.177.324,1.01,1.01,0,0,0-.418.845.967.967,0,0,0,.5.818,5.559,5.559,0,0,0,1.452.616,6.265,6.265,0,0,1,2.574,1.308,2.621,2.621,0,0,1,.812,1.955,2.414,2.414,0,0,1-.979,2.046,4.313,4.313,0,0,1-2.65.749,5.122,5.122,0,0,1-2.11-.417,3.337,3.337,0,0,1-1.454-1.157,2.972,2.972,0,0,1-.505-1.707l2.074-.006q.005,1.661,1.99,1.654a1.931,1.931,0,0,0,1.15-.3A.977.977,0,0,0,1435.057,1163Z",
    transform: "translate(-1412.459 -1155.369)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1479.024,1162.86a1.061,1.061,0,0,0-.416-.9,5.429,5.429,0,0,0-1.491-.657,10.542,10.542,0,0,1-1.7-.68,2.781,2.781,0,0,1-1.717-2.482,2.423,2.423,0,0,1,.454-1.452,2.99,2.99,0,0,1,1.313-1,4.952,4.952,0,0,1,1.925-.364,4.511,4.511,0,0,1,1.917.383,3.049,3.049,0,0,1,1.309,1.1,2.876,2.876,0,0,1,.47,1.611l-2.067.006a1.353,1.353,0,0,0-.437-1.07,1.786,1.786,0,0,0-1.221-.379,1.907,1.907,0,0,0-1.177.324,1.01,1.01,0,0,0-.418.846.968.968,0,0,0,.5.818,5.569,5.569,0,0,0,1.452.616,6.265,6.265,0,0,1,2.574,1.308,2.62,2.62,0,0,1,.812,1.954,2.414,2.414,0,0,1-.979,2.046,4.313,4.313,0,0,1-2.65.749,5.123,5.123,0,0,1-2.11-.417,3.335,3.335,0,0,1-1.454-1.157,2.975,2.975,0,0,1-.505-1.708l2.074-.006q.005,1.661,1.99,1.655a1.932,1.932,0,0,0,1.15-.3A.976.976,0,0,0,1479.024,1162.86Z",
    transform: "translate(-1447.751 -1155.261)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1524.563,1162.92l1.329-7.143,2.06-.006-2.195,10.04-2.081.006-1.654-6.707-1.612,6.717-2.081.006-2.257-10.026,2.06-.007,1.379,7.121,1.632-7.13,1.75-.005Z",
    transform: "translate(-1482.004 -1155.617)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1589.021,1160.362a6.057,6.057,0,0,1-.516,2.6,3.944,3.944,0,0,1-1.493,1.727,4.429,4.429,0,0,1-4.462.021,3.981,3.981,0,0,1-1.521-1.708,5.882,5.882,0,0,1-.552-2.558v-.5a6.025,6.025,0,0,1,.526-2.61,3.976,3.976,0,0,1,1.5-1.734,4.422,4.422,0,0,1,4.458-.014,3.976,3.976,0,0,1,1.514,1.725,6,6,0,0,1,.542,2.6Zm-2.1-.448a4.223,4.223,0,0,0-.572-2.4,2,2,0,0,0-3.218,0,4.175,4.175,0,0,0-.565,2.376l0,.489a4.275,4.275,0,0,0,.572,2.382,1.979,1.979,0,0,0,3.225.021,4.253,4.253,0,0,0,.558-2.383Z",
    transform: "translate(-1533.699 -1154.993)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1635.05,1161.9l-1.647.005.011,3.673-2.067.006-.031-10.033,3.728-.012a4.216,4.216,0,0,1,2.745.784,2.735,2.735,0,0,1,.972,2.236,3.085,3.085,0,0,1-.439,1.714,3.029,3.029,0,0,1-1.344,1.1l2.183,4.094v.1l-2.219.007Zm-1.652-1.669,1.667-.005a1.709,1.709,0,0,0,1.2-.4,1.416,1.416,0,0,0,.424-1.094,1.515,1.515,0,0,0-.406-1.115,1.676,1.676,0,0,0-1.238-.4l-1.661.005Z",
    transform: "translate(-1574.509 -1155.434)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1676.992,1165.455l-.031-10.033,3.087-.01a4.69,4.69,0,0,1,2.369.589,4.157,4.157,0,0,1,1.635,1.69,5.226,5.226,0,0,1,.594,2.5v.462a5.242,5.242,0,0,1-.568,2.489,4.119,4.119,0,0,1-1.618,1.693,4.725,4.725,0,0,1-2.362.614Zm2.041-8.365.021,6.7,1,0a2.245,2.245,0,0,0,1.851-.8,3.581,3.581,0,0,0,.648-2.269l0-.531a3.638,3.638,0,0,0-.641-2.317,2.238,2.238,0,0,0-1.856-.784Z",
    transform: "translate(-1611.147 -1155.33)",
    fill: "#363e44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(15.537 24.085)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 3.388,
    cy: 3.388,
    r: 3.388,
    transform: "translate(0 6.625) rotate(-67.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 3.388,
    cy: 3.388,
    r: 3.388,
    transform: "translate(13.236 2.272) rotate(-13.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 3.388,
    cy: 3.388,
    r: 3.388,
    transform: "translate(25.356 6.625) rotate(-67.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 3.388,
    cy: 3.388,
    r: 3.388,
    transform: "translate(38.591 2.272) rotate(-13.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 3.388,
    cy: 3.388,
    r: 3.388,
    transform: "translate(50.841 4.791) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 3.388,
    cy: 3.388,
    r: 3.388,
    transform: "translate(64.09 6.625) rotate(-67.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2494_2",
    "data-name": "XMLID_2494_",
    d: "M57.171,40.956a40.378,40.378,0,0,0,4.149-2.575,32.617,32.617,0,0,1,12.16,25.607,2.285,2.285,0,0,1-1.86,2.146,21.12,21.12,0,0,1-11.874-1.86A21.448,21.448,0,0,1,48.015,50.4a20.573,20.573,0,0,1,3.863-5.579,16.876,16.876,0,0,0,8.44,14.592,17.242,17.242,0,0,0,8.3,2.289A28.128,28.128,0,0,0,57.171,40.956Zm-5.579-25.75a21.678,21.678,0,0,1,20.171-8.44,2.463,2.463,0,0,1,1.717,2.146A32.728,32.728,0,0,1,60.6,35.091c-2.861,2.432-6.581,3.719-9.3,6.151a24.264,24.264,0,0,0-8.154,14.163c-.715,4.292-.429,8.583-.429,12.875A2.366,2.366,0,0,1,38,68.137c-.143-5.579.572-11.445-1.574-16.881-.143-3.147,0-6.295,0-9.442A26.982,26.982,0,0,1,40.147,48.4a35.1,35.1,0,0,1,7.01-10.014V27.652A22.326,22.326,0,0,1,51.592,15.206ZM7.1,8.769a2.024,2.024,0,0,1,1.86-2A22.026,22.026,0,0,1,22.694,9.627,21.767,21.767,0,0,1,33.28,28.8V44.819A21.646,21.646,0,0,1,10.534,66.564c-1,0-2.289,0-2.861-.858a6.487,6.487,0,0,1-.429-3.576A33.472,33.472,0,0,1,19.261,38.381c1.431.858,2.861,1.86,4.292,2.575A28.034,28.034,0,0,0,11.965,61.7,16.946,16.946,0,0,0,27.844,50.255c1.144-3,.858-6.295,1-9.442-2-1.86-4.578-2.861-6.867-4.435A33.215,33.215,0,0,1,7.1,8.769ZM38.859,35.52a2.317,2.317,0,1,1,1.288,4.149C38.144,39.669,37.143,36.665,38.859,35.52ZM38.716,24.5a3.94,3.94,0,0,1,5.436,3.29,4.054,4.054,0,0,1-3.576,4.149,3.9,3.9,0,0,1-1.86-7.439Zm.715-7.868a2.321,2.321,0,1,1-1,3.576A2.392,2.392,0,0,1,39.432,16.637Zm13.59,5.293c-1.717,4.149-.858,8.726-1.144,13.018a37.809,37.809,0,0,0,8.3-5.865,28.942,28.942,0,0,0,8.583-18.025A17.282,17.282,0,0,0,53.022,21.93ZM11.965,11.2a29.6,29.6,0,0,0,5.579,14.878c2.861,4.006,7.01,6.724,11.158,9.013V27.938a16.245,16.245,0,0,0-4.721-11.445A16.383,16.383,0,0,0,11.965,11.2Z",
    transform: "translate(41.769 37.753)",
    fill: "#f26149",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(-4325.708 -2700.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(4718.24 2835.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(2.494 16.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M4830.645,2889.844s3.631-1.266,3.667-3.644-27.16-5.782-32.36,7.5c0,0,1.018.721,5.221.447",
    transform: "translate(-4801.952 -2883.971)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(2.494 16.921)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M4830.645,2889.844s3.631-1.266,3.667-3.644-27.16-5.782-32.36,7.5c0,0,1.018.721,5.221.447",
    transform: "translate(-4801.952 -2883.971)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(2.161 13.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(3.746 4.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M4814.358,2930.024l16.6-1.326c.1-1.938-.035-9.435-.035-9.435s6.906-1.074,6.991-7.979-1.112-22.761-1.112-22.761h0a24,24,0,0,0-24.113,3.032l-1.023.787Z",
    transform: "translate(-4811.666 -2886.573)",
    fill: "#ffc19d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(15.562 21.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M4856,2949.108a17.84,17.84,0,0,0,4.665,1.355,2.629,2.629,0,0,1-3.1,1.046C4855.5,2950.752,4856,2949.108,4856,2949.108Z",
    transform: "translate(-4855.949 -2949.108)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(10.267 30.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M4849.883,2974.594a16.057,16.057,0,0,1-9-2.559s2.127,4.97,9.018,4.348Z",
    transform: "translate(-4840.881 -2972.035)",
    fill: "#ff9c6a"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(2.177 3.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M4834.049,2887.15s-4.04,2.339-9.694.021c-3.711-1.521-7.947-2.085-8.813-1.3s-.787,4.489-4.252,5.828c0,0,.764,7.017-2.06,6.974s-1.877-11.069-1.877-11.069l6.614-3.859,7.383-1.969,7.129.473,5.57,1.091Z",
    transform: "translate(-4807.2 -2881.778)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(0 17.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M4805.6,2922.943c-.118-.051-4.745-1.4-4.594,3.317s4.859,3.6,4.863,3.46S4805.6,2922.943,4805.6,2922.943Z",
    transform: "translate(-4801.004 -2922.725)",
    fill: "#ffc19d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(1.202 1.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M4806.59,2930.83c-.021-.015-.081.06-.218.128a.822.822,0,0,1-.614.032,2.035,2.035,0,0,1-1-1.8,2.708,2.708,0,0,1,.192-1.185.951.951,0,0,1,.6-.651.419.419,0,0,1,.493.21c.067.13.041.225.066.232s.1-.082.055-.276a.528.528,0,0,0-.2-.29.624.624,0,0,0-.459-.105,1.157,1.157,0,0,0-.835.76,2.789,2.789,0,0,0-.243,1.325,2.135,2.135,0,0,0,1.264,2,.883.883,0,0,0,.749-.149C4806.585,2930.944,4806.607,2930.838,4806.59,2930.83Z",
    transform: "translate(-4804.425 -2927.123)",
    fill: "#ff9c6a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(1.389 2.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M4804.961,2881.152c.039.155.738.094,1.521.349.79.236,1.331.685,1.45.579.125-.082-.326-.814-1.284-1.11S4804.9,2881.014,4804.961,2881.152Z",
    transform: "translate(-4804.958 -2880.85)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(3.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M4812.138,2873.234a3.152,3.152,0,0,0-.15,2.247c.248,1.284,1.057,2.047,1.157,1.939.127-.1-.4-.912-.613-2.051S4812.308,2873.241,4812.138,2873.234Z",
    transform: "translate(-4811.887 -2873.234)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M4814.766,2854.015c12.447-1.354,14.833.844,14.944.955a2.547,2.547,0,0,0,.639-1.236c.445-3.678-4.016-4.716-4.016-4.716-2.792-12.733-14.239-11.432-14.239-11.432l-.019-.1a2.058,2.058,0,0,0-2.409-1.633l-1.789.343a2.057,2.057,0,0,0-1.632,2.409h0c-13.427,4.475-8.969,16.888-8.969,16.888l-1.963,2.372c-1.742,3.527,2.035,4.6,2.035,4.6S4802,2855.4,4814.766,2854.015Z",
    transform: "translate(-4794.855 -2835.819)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(11.116 3.017)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M4829.017,2855.236a55.741,55.741,0,0,0-2.5-10.832,55.73,55.73,0,0,0,2.5,10.832Z",
    transform: "translate(-4826.487 -2844.404)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(17.368 1.807)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M4847.251,2851.349a52.524,52.524,0,0,0-2.946-10.386,52.511,52.511,0,0,0,2.946,10.386Z",
    transform: "translate(-4844.28 -2840.962)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(3.255 12.545)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M4831.78,2872.711a4.141,4.141,0,0,0-1.087-.387,21.408,21.408,0,0,0-3.085-.606,28.885,28.885,0,0,0-10.326.662,37.439,37.439,0,0,0-9.6,3.877c-1.151.658-2.052,1.24-2.659,1.665a4.394,4.394,0,0,0-.906.712c.049.076,1.423-.81,3.753-2.032a42.466,42.466,0,0,1,9.541-3.681,31.549,31.549,0,0,1,10.153-.811C4830.181,2872.343,4831.756,2872.809,4831.78,2872.711Z",
    transform: "translate(-4804.119 -2871.518)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(1.024 16.08)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M4810.991,2881.6a7.055,7.055,0,0,0-2.205.42,25.141,25.141,0,0,0-9.464,5.151,7.13,7.13,0,0,0-1.55,1.624,40.032,40.032,0,0,1,13.219-7.195Z",
    transform: "translate(-4797.77 -2881.579)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(11.811 0.99)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M4828.881,2841.229c.146-.063.029-.636.171-1.3.123-.67.449-1.156.338-1.269-.089-.122-.717.3-.884,1.161S4828.752,2841.307,4828.881,2841.229Z",
    transform: "translate(-4828.466 -2838.637)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529",
    transform: "translate(2.294 4.13)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M4802.678,2861.278c.767-.158.483-3.769,2.405-7.343,1.858-3.61,5-5.42,4.691-6.141-.136-.339-1.185-.341-2.661.373a10.631,10.631,0,0,0-5.635,10.707C4801.726,2860.494,4802.321,2861.357,4802.678,2861.278Z",
    transform: "translate(-4801.382 -2847.573)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    transform: "translate(4760.352 2916.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M5084.356,3112.015s8.212-4.211,9.649-6.127,2.045-8.663,2.045-8.663l-14,5.232Z",
    transform: "translate(-5023.24 -3085.549)",
    fill: "#ffc19d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M4914.693,3072.849c.484.162,9.53,20.347,16.8,20.448,7.328.1,44.319-2.83,44.319-2.83l-2.306-9.559-35.532-1.146L4926.328,3064Z",
    transform: "translate(-4914.693 -3064)",
    fill: "#ffc19d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(4677.823 3155.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M4697.089,3744.794l-1.646,6.911s-11.3,14.681-14.789,13.963c-2.285-.47.522-4.3,4.822-15.451l.9-4.606Z",
    transform: "translate(-4679.838 -3744.794)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(0.355 5.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M4680.85,3773.19a.6.6,0,0,0,.089.208,1.253,1.253,0,0,0,.475.444,1.861,1.861,0,0,0,1.005.221,2.675,2.675,0,0,0,1.28-.469,54.863,54.863,0,0,0,5.7-5.31,72.581,72.581,0,0,0,5.052-5.92c.6-.793,1.074-1.446,1.392-1.9l.359-.531a.867.867,0,0,0,.113-.194.847.847,0,0,0-.149.167l-.393.506-1.446,1.859c-1.237,1.555-3,3.667-5.089,5.863a63.419,63.419,0,0,1-5.622,5.332,2.091,2.091,0,0,1-2.158.3A1.486,1.486,0,0,1,4680.85,3773.19Z",
    transform: "translate(-4680.85 -3759.735)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(1.956 13.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M4685.4,3784.38c.006.038.357-.033.914.047a5.4,5.4,0,0,1,2.035.771,4.172,4.172,0,0,1,1.526,1.523c.267.493.34.845.378.834a1.951,1.951,0,0,0-.238-.905,3.9,3.9,0,0,0-1.55-1.642,4.841,4.841,0,0,0-2.135-.738A1.766,1.766,0,0,0,4685.4,3784.38Z",
    transform: "translate(-4685.405 -3784.263)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    transform: "translate(12.23 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M4715.069,3761.944c.039-.01-.118-.495-.208-1.3a5.321,5.321,0,0,1,.567-3.028,5,5,0,0,1,2.16-2.181,8.654,8.654,0,0,1,1.225-.446.961.961,0,0,0-.357.019,3.726,3.726,0,0,0-.935.286,4.856,4.856,0,0,0-2.291,2.222,5.137,5.137,0,0,0-.525,3.149,5.932,5.932,0,0,0,.226.947A1.033,1.033,0,0,0,4715.069,3761.944Z",
    transform: "translate(-4714.642 -3754.984)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(15.518 1.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M4725.011,3748.129a6.993,6.993,0,0,0-.626,2.165c-.207,1.227-.429,2.2-.379,2.214a7.181,7.181,0,0,0,.6-2.173C4724.814,3749.115,4725.066,3748.149,4725.011,3748.129Z",
    transform: "translate(-4723.999 -3748.128)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(5.437 6.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M4695.312,3762.831c0,.065.645.046,1.4.224s1.325.469,1.357.412a3.3,3.3,0,0,0-2.759-.636Z",
    transform: "translate(-4695.312 -3762.739)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(5.205 7.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M4694.65,3766.138c.01.064.545.009,1.172.163s1.083.436,1.121.381a2.244,2.244,0,0,0-2.293-.544Z",
    transform: "translate(-4694.65 -3766.013)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(4.301 8.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M4692.081,3770.181a3.28,3.28,0,0,1,2.336.531,1.824,1.824,0,0,0-2.336-.531Z",
    transform: "translate(-4692.079 -3769.957)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(6.215 3.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M4697.525,3756.32a1.161,1.161,0,0,0,.379-.042,7.511,7.511,0,0,0,1-.27,8.941,8.941,0,0,0,2.185-1.108,1.139,1.139,0,0,0,.564-.869.667.667,0,0,0-.862-.54,1.79,1.79,0,0,0-.787.527,14.2,14.2,0,0,0-1.039,1.132c-.277.338-.484.625-.621.828a1.189,1.189,0,0,0-.188.33c.027.02.351-.41.929-1.055.289-.322.645-.7,1.061-1.087a1.641,1.641,0,0,1,.694-.462c.256-.065.587.073.592.34s-.242.51-.471.68c-.25.177-.5.338-.75.48a10.255,10.255,0,0,1-1.361.657C4698.046,3756.174,4697.517,3756.284,4697.525,3756.32Z",
    transform: "translate(-4697.525 -3753.466)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(4.72 2.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M4695.36,3754.3a1.059,1.059,0,0,0,.013-.346c-.008-.222-.021-.542-.071-.939a4.941,4.941,0,0,0-.354-1.365,2.912,2.912,0,0,0-.445-.724.759.759,0,0,0-.9-.286.872.872,0,0,0-.313.9,3.176,3.176,0,0,0,.248.812,4.165,4.165,0,0,0,.807,1.16,5.058,5.058,0,0,0,.721.614.937.937,0,0,0,.3.173c.024-.031-.384-.312-.906-.893a4.344,4.344,0,0,1-.735-1.137,3.114,3.114,0,0,1-.219-.756c-.032-.255,0-.57.2-.68s.463.043.635.237a2.842,2.842,0,0,1,.421.663,5.288,5.288,0,0,1,.386,1.3A10.868,10.868,0,0,0,4695.36,3754.3Z",
    transform: "translate(-4693.271 -3750.573)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(0.018 3.59)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M4695.477,3758.331l.8-3.322s-2.77.512-3.488,2.585a8.691,8.691,0,0,0-.541,3.548l-6.021,6.484s-1.511-2.951-4.246-2.242c0,0-2.152,4.733-2.085,5.92.073,1.3,1.446,1.043,1.936.82a24.288,24.288,0,0,0,5.391-4.254C4690.409,3764.562,4693.933,3760.365,4695.477,3758.331Z",
    transform: "translate(-4679.891 -3755.009)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(4733.593 3149.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(0.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M4856.657,3737.334l.053-9.218-17.264-.209-.22,13.484,1.07.082c4.76.322,24.229,1.3,27.426.376C4871.286,3740.815,4856.657,3737.334,4856.657,3737.334Z",
    transform: "translate(-4839.226 -3727.908)",
    fill: "#554494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(0.021 8.4)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M4845.525,3756.836a5.989,5.989,0,0,0-2.158-3.708,5.816,5.816,0,0,0-4.02-1.3l-.062,4.826Z",
    transform: "translate(-4839.284 -3751.812)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(0.239 11.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M4863.8,3760.3s5.124,1.546,4.472,2.385-20.363.588-29.049-.283l.032-.386,22.99.489S4862.8,3760.33,4863.8,3760.3Z",
    transform: "translate(-4839.226 -3760.3)",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(0 13.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M4838.546,3765.128a1.5,1.5,0,0,0,.3.037l.852.062,3.136.175c2.649.129,6.312.259,10.358.314s7.712.023,10.364-.034l3.139-.091.854-.04a1.664,1.664,0,0,0,.3-.027,1.624,1.624,0,0,0-.3-.015h-.854l-3.14.024c-2.651.02-6.314.027-10.359-.026s-7.705-.162-10.355-.252l-3.138-.109-.854-.023A1.732,1.732,0,0,0,4838.546,3765.128Z",
    transform: "translate(-4838.546 -3765.121)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(23.225 11.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M4904.666,3762.383a7.022,7.022,0,0,1,.605-1.49,6.945,6.945,0,0,1,1.085-1.187,2.79,2.79,0,0,0-1.69,2.678Z",
    transform: "translate(-4904.638 -3759.699)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(18.184 9.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M4890.3,3757.162c.048.032.3-.262.553-.656s.426-.738.377-.769-.3.261-.553.655S4890.251,3757.131,4890.3,3757.162Z",
    transform: "translate(-4890.292 -3755.735)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(16.799 9.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M4886.355,3755.869c.039.044.313-.135.613-.4s.515-.512.476-.556-.312.135-.613.4S4886.317,3755.826,4886.355,3755.869Z",
    transform: "translate(-4886.351 -3754.909)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(15.941 8.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M4883.908,3752.816a3.952,3.952,0,1,0,.9-.083A2.053,2.053,0,0,0,4883.908,3752.816Z",
    transform: "translate(-4883.908 -3752.731)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(15.651 7.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M4883.084,3749.662a2.533,2.533,0,0,0,2.041.18,73.515,73.515,0,0,1-2.041-.18Z",
    transform: "translate(-4883.084 -3749.646)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(18.797 8.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M4892.036,3752.718a3.219,3.219,0,0,0,1.109.007,6.528,6.528,0,0,0,1.185-.245,3.2,3.2,0,0,0,.68-.271.6.6,0,0,0,.279-.341.435.435,0,0,0-.163-.445,2.035,2.035,0,0,0-2.523.563,2.006,2.006,0,0,0-.372.736.635.635,0,0,0-.033.3,3.14,3.14,0,0,1,.518-.94,2,2,0,0,1,.956-.6,1.724,1.724,0,0,1,1.321.106c.175.133.1.339-.095.454a3.328,3.328,0,0,1-.626.258,7.667,7.667,0,0,1-1.146.283C4892.46,3752.688,4892.036,3752.684,4892.036,3752.718Z",
    transform: "translate(-4892.036 -3751.194)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(17.657 7.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M4890.219,3751.711a1.1,1.1,0,0,0,.138-.769,1.825,1.825,0,0,0-.293-.814,1.114,1.114,0,0,0-.916-.578.442.442,0,0,0-.349.508,1.224,1.224,0,0,0,.182.5,3.384,3.384,0,0,0,.516.678,1.6,1.6,0,0,0,.63.457c.02-.027-.22-.2-.52-.557a3.876,3.876,0,0,1-.457-.671c-.149-.237-.248-.659.031-.707.278-.023.558.257.725.48a1.826,1.826,0,0,1,.3.726A3.975,3.975,0,0,1,4890.219,3751.711Z",
    transform: "translate(-4888.793 -3749.55)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(0.413 8.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M4839.72,3751.52c0,.039.5-.041,1.274.061a5.409,5.409,0,0,1,4.476,3.662c.254.744.273,1.241.312,1.237a.989.989,0,0,0,0-.349,4.533,4.533,0,0,0-.176-.934,5.247,5.247,0,0,0-4.6-3.764,4.6,4.6,0,0,0-.95.012A.989.989,0,0,0,4839.72,3751.52Z",
    transform: "translate(-4839.72 -3751.415)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(2.065 1.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M4844.651,3731.333a30.265,30.265,0,0,0-.194,3.544,29.932,29.932,0,0,0,.015,3.55,60.272,60.272,0,0,0,.18-7.094Z",
    transform: "translate(-4844.423 -3731.333)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(8.694 11.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M4863.288,3761.364a14.173,14.173,0,0,0,5.045.113c0-.061-1.133-.006-2.523-.039S4863.295,3761.3,4863.288,3761.364Z",
    transform: "translate(-4863.288 -3761.345)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(5.302 11.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M4853.643,3761.249c-.042.042.089.24.2.5s.172.49.232.487.092-.272-.04-.571S4853.682,3761.208,4853.643,3761.249Z",
    transform: "translate(-4853.635 -3761.243)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(4.047 10.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M4850.07,3756.685c-.042.04.067.221.244.4s.354.3.4.259-.067-.221-.244-.4S4850.112,3756.644,4850.07,3756.685Z",
    transform: "translate(-4850.062 -3756.677)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(2.239 9.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M4844.919,3754.394c.012.059.241.06.493.152s.434.23.479.191-.1-.279-.41-.388S4844.9,3754.34,4844.919,3754.394Z",
    transform: "translate(-4844.918 -3754.299)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(0.942 8.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M4841.23,3753.478c-.021.054.077.144.22.2s.275.06.3.007-.076-.144-.219-.2S4841.253,3753.425,4841.23,3753.478Z",
    transform: "translate(-4841.228 -3753.44)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M4738.215,3083.887l52.143,2.96c.137-5.722-2.051-51.715-2.051-51.715l2.871,5.386,14.921-13.308-13.038-17.621a25.822,25.822,0,0,0-17.272-10.215c-2.024-.276-3.563-.409-4.563-.535a29.371,29.371,0,0,1-17.7-.01h0a24.111,24.111,0,0,0-7.328,1.4,30.175,30.175,0,0,0-11.693,7.569v0l-15.615,26.241,18.935,11.91,2.731-8.254Z",
    transform: "translate(-27.345 -105.727)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(4676.731 2892.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(0 82.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M4763.012,3233.808l-8.058,179.084-26.886.565,4.466-149.927L4702.293,3414.6h-25.562l34.139-180.794",
    transform: "translate(-4676.731 -3233.808)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(0 177.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M4703.623,3739.271l-.616,2.646-26.276.353.4-4.139Z",
    transform: "translate(-4676.731 -3738.132)",
    fill: "#f26149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(55.656 30.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(0 147.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M4835.433,3740.592c-.153-.007-.3.344-.318.785s.083.8.236.813.3-.343.319-.784S4835.587,3740.6,4835.433,3740.592Z",
    transform: "translate(-4835.112 -3740.592)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(0.241 141.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M4836.143,3722.143c-.153,0-.3.717-.338,1.612s.064,1.626.217,1.632.3-.715.338-1.612S4836.3,3722.147,4836.143,3722.143Z",
    transform: "translate(-4835.798 -3722.143)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(0.452 134.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M4836.724,3703.676c-.153,0-.3.718-.323,1.615s.079,1.626.232,1.63.3-.719.323-1.615S4836.878,3703.68,4836.724,3703.676Z",
    transform: "translate(-4836.398 -3703.676)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(0.619 128.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M4837.194,3685.2c-.154,0-.3.72-.317,1.616s.085,1.626.239,1.63.295-.72.316-1.617S4837.347,3685.207,4837.194,3685.2Z",
    transform: "translate(-4836.875 -3685.203)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(0.775 121.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M4837.638,3666.72c-.153,0-.295.72-.317,1.616s.084,1.627.238,1.631.3-.72.317-1.617S4837.792,3666.724,4837.638,3666.72Z",
    transform: "translate(-4837.318 -3666.72)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(0.948 115.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M4838.14,3648.234c-.153,0-.3.719-.326,1.615s.075,1.628.229,1.632.3-.719.326-1.616S4838.294,3648.238,4838.14,3648.234Z",
    transform: "translate(-4837.81 -3648.234)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(1.174 108.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M4838.809,3629.766c-.153-.006-.309.714-.348,1.61s.058,1.628.212,1.634.307-.715.344-1.61S4838.962,3629.773,4838.809,3629.766Z",
    transform: "translate(-4838.454 -3629.766)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(1.445 102.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M4839.572,3611.3c-.153-.006-.306.715-.342,1.611s.06,1.627.214,1.633.306-.715.342-1.611S4839.726,3611.31,4839.572,3611.3Z",
    transform: "translate(-4839.223 -3611.304)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(1.689 95.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M4840.258,3592.837c-.154-.006-.3.717-.335,1.613s.067,1.627.221,1.632.3-.716.335-1.613S4840.411,3592.842,4840.258,3592.837Z",
    transform: "translate(-4839.917 -3592.837)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(1.903 89.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M4840.858,3574.362c-.153,0-.3.719-.327,1.615s.074,1.627.228,1.632.3-.718.328-1.615S4841.012,3574.367,4840.858,3574.362Z",
    transform: "translate(-4840.527 -3574.362)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(2.086 82.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M4841.37,3555.9c-.153,0-.3.719-.319,1.615s.083,1.626.237,1.63.3-.72.319-1.616S4841.523,3555.9,4841.37,3555.9Z",
    transform: "translate(-4841.048 -3555.901)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(2.237 76.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M4841.792,3537.427c-.154,0-.293.721-.312,1.617s.091,1.626.244,1.629.293-.721.311-1.617S4841.945,3537.43,4841.792,3537.427Z",
    transform: "translate(-4841.479 -3537.427)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(2.355 69.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M4842.118,3518.952c-.153,0-.289.723-.3,1.619s.1,1.625.253,1.627.289-.722.3-1.619S4842.271,3518.955,4842.118,3518.952Z",
    transform: "translate(-4841.814 -3518.952)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(2.439 63.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M4842.348,3500.476c-.153,0-.285.724-.294,1.62s.107,1.625.261,1.626.286-.724.294-1.621S4842.5,3500.478,4842.348,3500.476Z",
    transform: "translate(-4842.053 -3500.476)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(2.488 56.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M4842.479,3482c-.153,0-.282.726-.286,1.622s.116,1.624.27,1.625.282-.726.287-1.622S4842.632,3482,4842.479,3482Z",
    transform: "translate(-4842.192 -3481.999)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(2.502 50.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M4842.509,3463.521c-.153,0-.278.727-.277,1.624s.125,1.624.279,1.624.277-.727.276-1.624S4842.663,3463.521,4842.509,3463.521Z",
    transform: "translate(-4842.232 -3463.521)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(2.48 43.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M4842.438,3445.044c-.154,0-.274.729-.269,1.625s.134,1.623.288,1.622.273-.728.268-1.625S4842.591,3445.043,4842.438,3445.044Z",
    transform: "translate(-4842.169 -3445.044)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(2.422 37.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M4842.265,3426.566c-.153,0-.27.73-.259,1.627s.143,1.622.3,1.62.27-.73.259-1.627S4842.419,3426.564,4842.265,3426.566Z",
    transform: "translate(-4842.005 -3426.566)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(2.329 30.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M4841.992,3408.1c-.154,0-.266.731-.25,1.627s.151,1.62.3,1.617.266-.731.25-1.627S4842.145,3408.093,4841.992,3408.1Z",
    transform: "translate(-4841.74 -3408.096)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(2.203 24.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M4841.626,3389.613c-.154,0-.263.733-.243,1.63s.159,1.622.313,1.618.262-.733.243-1.63S4841.779,3389.61,4841.626,3389.613Z",
    transform: "translate(-4841.38 -3389.613)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(2.021 17.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M4841.091,3371.125c-.153.006-.252.738-.221,1.633s.181,1.619.334,1.615.252-.736.221-1.634S4841.244,3371.119,4841.091,3371.125Z",
    transform: "translate(-4840.864 -3371.125)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(1.708 11.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M4840.167,3352.661c-.153.01-.234.744-.18,1.638s.222,1.612.375,1.6.234-.741.18-1.638S4840.32,3352.65,4840.167,3352.661Z",
    transform: "translate(-4839.971 -3352.661)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(1.175 4.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M4838.615,3334.251c-.153.017-.206.753-.118,1.643s.282,1.6.435,1.588.205-.749.118-1.643S4838.768,3334.234,4838.615,3334.251Z",
    transform: "translate(-4838.455 -3334.251)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(0.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M4836.812,3320.58c-.152.023-.225.4-.163.832s.235.774.388.753.225-.392.163-.831S4836.964,3320.557,4836.812,3320.58Z",
    transform: "translate(-4836.627 -3320.579)",
    fill: "#f26149"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(50.492 175.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M4848.851,3738.019l-28.433.463.223-4.737,28.209.149Z",
    transform: "translate(-4820.418 -3733.746)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(47.092 33.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M4810.743,3148.326l2.859-54.71h31.354l5.083,56.272Z",
    transform: "translate(-4810.743 -3093.616)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(40.292 0.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M4791.391,3001.391s12.7,3.332,12.914,33.16h5.12s1.342-25.052-12.478-34.892C4796.947,2999.659,4792.957,2998.7,4791.391,3001.391Z",
    transform: "translate(-4791.391 -2999.493)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(67.15 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M4867.822,2998.144s9.021,4.272,9.237,34.1h4.35s.366-27.931-8.156-33.442A6.093,6.093,0,0,0,4867.822,2998.144Z",
    transform: "translate(-4867.822 -2997.757)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(4.926 98.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(0 159.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M4691.182,3733.978c-.151-.025-.332.309-.4.745s-.005.81.146.835.332-.309.4-.746S4691.333,3734,4691.182,3733.978Z",
    transform: "translate(-4690.75 -3733.976)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(0.819 153.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M4693.711,3716.265c-.151-.025-.389.652-.529,1.511s-.132,1.576.02,1.6.388-.652.529-1.511S4693.863,3716.29,4693.711,3716.265Z",
    transform: "translate(-4693.082 -3716.264)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(1.842 147.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M4696.626,3698.556c-.151-.025-.389.651-.531,1.51s-.135,1.576.017,1.6.389-.651.532-1.51S4696.778,3698.581,4696.626,3698.556Z",
    transform: "translate(-4695.993 -3698.555)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(2.875 141.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M4699.571,3680.851c-.152-.025-.39.65-.534,1.509s-.137,1.576.014,1.6.391-.65.535-1.51S4699.722,3680.876,4699.571,3680.851Z",
    transform: "translate(-4698.933 -3680.85)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(3.918 134.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M4702.542,3663.151c-.152-.025-.392.65-.537,1.509s-.14,1.576.011,1.6.393-.65.536-1.509S4702.692,3663.177,4702.542,3663.151Z",
    transform: "translate(-4701.9 -3663.15)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(4.97 128.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M4705.541,3645.456c-.151-.025-.392.649-.539,1.507s-.143,1.576.009,1.6.392-.649.538-1.508S4705.691,3645.482,4705.541,3645.456Z",
    transform: "translate(-4704.895 -3645.455)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(6.032 122.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M4708.566,3627.766c-.151-.026-.394.648-.541,1.507s-.145,1.575.006,1.6.394-.648.541-1.507S4708.718,3627.792,4708.566,3627.766Z",
    transform: "translate(-4707.917 -3627.765)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(7.104 116.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M4711.621,3610.08c-.152-.026-.4.648-.544,1.506s-.147,1.575,0,1.6.394-.648.543-1.506S4711.771,3610.106,4711.621,3610.08Z",
    transform: "translate(-4710.966 -3610.079)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(8.185 110.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M4714.7,3592.4c-.151-.026-.4.648-.546,1.506s-.149,1.575,0,1.6.4-.647.546-1.506S4714.853,3592.425,4714.7,3592.4Z",
    transform: "translate(-4714.043 -3592.398)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(9.277 103.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M4717.811,3574.723c-.151-.027-.4.647-.548,1.5s-.152,1.575,0,1.6.4-.647.548-1.5S4717.962,3574.75,4717.811,3574.723Z",
    transform: "translate(-4717.148 -3574.722)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(10.377 97.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M4720.947,3557.052c-.151-.027-.4.646-.55,1.5s-.154,1.574,0,1.6.4-.646.551-1.5S4721.1,3557.079,4720.947,3557.052Z",
    transform: "translate(-4720.281 -3557.051)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(11.488 91.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M4724.111,3539.385c-.151-.027-.4.646-.552,1.5s-.157,1.574-.005,1.6.4-.646.552-1.5S4724.263,3539.412,4724.111,3539.385Z",
    transform: "translate(-4723.442 -3539.384)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(12.608 85.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M4727.3,3521.724c-.151-.027-.4.645-.555,1.5s-.159,1.574-.008,1.6.4-.645.554-1.5S4727.455,3521.751,4727.3,3521.724Z",
    transform: "translate(-4726.629 -3521.723)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(13.738 78.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M4730.523,3504.068c-.151-.028-.4.644-.558,1.5s-.162,1.573-.011,1.6.4-.644.558-1.5S4730.674,3504.095,4730.523,3504.068Z",
    transform: "translate(-4729.845 -3504.067)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(14.878 72.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M4733.77,3486.416c-.151-.028-.4.644-.56,1.5s-.164,1.573-.013,1.6.4-.643.56-1.5S4733.921,3486.444,4733.77,3486.416Z",
    transform: "translate(-4733.088 -3486.416)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(16.026 66.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M4737.043,3468.771c-.15-.028-.4.643-.562,1.5s-.167,1.573-.016,1.6.4-.643.562-1.5S4737.195,3468.8,4737.043,3468.771Z",
    transform: "translate(-4736.357 -3468.77)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(17.185 60.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M4740.347,3451.129c-.152-.028-.4.643-.565,1.5s-.169,1.573-.019,1.6.4-.642.565-1.5S4740.5,3451.158,4740.347,3451.129Z",
    transform: "translate(-4739.655 -3451.128)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(18.354 54.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M4743.676,3433.494c-.151-.029-.405.642-.566,1.5s-.172,1.572-.021,1.6.4-.642.567-1.5S4743.827,3433.522,4743.676,3433.494Z",
    transform: "translate(-4742.981 -3433.493)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(19.532 47.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M4747.032,3415.863c-.15-.029-.405.641-.568,1.5s-.174,1.572-.023,1.6.405-.641.569-1.5S4747.183,3415.891,4747.032,3415.863Z",
    transform: "translate(-4746.333 -3415.862)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(20.72 41.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M4750.417,3398.238c-.15-.029-.407.64-.572,1.5s-.177,1.572-.025,1.6.406-.64.571-1.5S4750.568,3398.267,4750.417,3398.238Z",
    transform: "translate(-4749.713 -3398.237)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(21.918 35.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M4753.829,3380.619c-.151-.03-.408.64-.574,1.494s-.179,1.571-.028,1.6.407-.64.574-1.495S4753.979,3380.648,4753.829,3380.619Z",
    transform: "translate(-4753.122 -3380.618)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(23.125 29.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M4757.269,3363c-.15-.03-.409.639-.576,1.494s-.181,1.571-.03,1.6.408-.639.576-1.494S4757.419,3363.033,4757.269,3363Z",
    transform: "translate(-4756.557 -3363.002)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(24.342 23.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M4760.736,3345.395c-.151-.03-.41.639-.579,1.493s-.184,1.571-.033,1.6.41-.639.579-1.493S4760.886,3345.424,4760.736,3345.395Z",
    transform: "translate(-4760.02 -3345.394)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(25.568 17.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M4764.23,3327.792c-.15-.03-.411.637-.581,1.491s-.186,1.571-.036,1.6.411-.638.581-1.492S4764.38,3327.822,4764.23,3327.792Z",
    transform: "translate(-4763.51 -3327.791)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(26.804 10.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M4767.752,3310.192c-.151-.03-.411.638-.583,1.491s-.189,1.571-.038,1.6.411-.638.583-1.492S4767.9,3310.223,4767.752,3310.192Z",
    transform: "translate(-4767.028 -3310.191)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(28.05 4.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M4771.3,3292.6c-.151-.031-.413.637-.585,1.49s-.191,1.57-.041,1.6.413-.637.585-1.491S4771.452,3292.631,4771.3,3292.6Z",
    transform: "translate(-4770.573 -3292.6)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(29.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M4774.467,3279.337c-.15-.031-.344.3-.433.729s-.039.81.112.84.344-.3.432-.729S4774.618,3279.368,4774.467,3279.337Z",
    transform: "translate(-4773.991 -3279.335)",
    fill: "#f26149"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(75.983 32.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M4893.228,3091.576a3.444,3.444,0,0,0-.269,1.585,3.87,3.87,0,0,0,.358,1.766,2.52,2.52,0,0,0,1.761,1.424,2.3,2.3,0,0,0,2.105-.854,2.812,2.812,0,0,0,.627-1.717,2.3,2.3,0,0,0-.374-1.577c-.092.02.094.622-.018,1.544a2.6,2.6,0,0,1-.622,1.415,1.847,1.847,0,0,1-1.626.641,2.09,2.09,0,0,1-1.4-1.113,3.911,3.911,0,0,1-.419-1.544A6.967,6.967,0,0,0,4893.228,3091.576Z",
    transform: "translate(-4892.958 -3091.576)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(77.539 33.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M4898.363,3093.638c.029-.065-.317-.207-.687.131a.939.939,0,1,0,1.5.285c-.222-.449-.6-.444-.592-.373-.026.076.173.2.22.5s-.121.667-.542.583a.456.456,0,0,1-.291-.74C4898.128,3093.761,4898.359,3093.719,4898.363,3093.638Z",
    transform: "translate(-4897.385 -3093.552)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(53.334 33.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M4828.715,3092.124a3.042,3.042,0,0,0-.208,1.5,3.406,3.406,0,0,0,.443,1.645,2.215,2.215,0,0,0,1.817,1.126,2.735,2.735,0,0,0,2-.739,3.233,3.233,0,0,0,.868-1.471,2.219,2.219,0,0,0,.043-1.523c-.09,0-.1.579-.415,1.4a3.18,3.18,0,0,1-.84,1.219,2.347,2.347,0,0,1-1.621.563,1.753,1.753,0,0,1-1.414-.842,3.411,3.411,0,0,1-.486-1.407A6.27,6.27,0,0,0,4828.715,3092.124Z",
    transform: "translate(-4828.506 -3092.124)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(55.249 33.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M4834.7,3093.649c.015-.07-.274-.157-.552.141a.773.773,0,0,0-.18.672.832.832,0,0,0,1.481.254.774.774,0,0,0,.054-.694c-.163-.374-.464-.387-.474-.317-.032.072.092.2.094.417,0,.236-.122.434-.4.386s-.331-.276-.25-.5S4834.711,3093.728,4834.7,3093.649Z",
    transform: "translate(-4833.956 -3093.581)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(54.737 46.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M4832.5,3131.387c-.019.034.244.215.735.517a22.323,22.323,0,0,0,2.158,1.144,32.592,32.592,0,0,0,15.71,3,22.093,22.093,0,0,0,2.429-.269,2.8,2.8,0,0,0,.873-.21c-.012-.091-1.275.051-3.316.086a38.366,38.366,0,0,1-15.536-2.963C4833.667,3131.9,4832.544,3131.307,4832.5,3131.387Z",
    transform: "translate(-4832.499 -3131.38)",
    fill: "#f26149"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(4706.691 2982.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M4761.991,3258.7l57.157-4.945v6.508l-57.157,4.864Z",
    transform: "translate(-4761.991 -3253.752)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(38.338 0.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M4871.865,3255.616a21.1,21.1,0,0,0,2.383-.072c1.467-.078,3.517-.2,5.934-.381l-.267-.291c-.35,1.967-.744,4.183-1.162,6.527-.03.175-.06.351-.09.522l.257-.23-7.589.495.246.25c.128-2,.207-3.683.256-4.88a15.921,15.921,0,0,0,.03-1.939,11.285,11.285,0,0,0-.253,1.789c-.133,1.178-.313,2.9-.5,5l-.023.265.27-.014,7.594-.405.219-.012.038-.218.091-.522c.4-2.348.771-4.566,1.1-6.537l.055-.32-.321.03c-2.513.235-4.613.464-6.06.633A15.933,15.933,0,0,0,4871.865,3255.616Z",
    transform: "translate(-4871.09 -3254.637)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(43.723 2.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M4892.745,3261.016a18.237,18.237,0,1,0-3.146.494A9.3,9.3,0,0,0,4892.745,3261.016Z",
    transform: "translate(-4886.416 -3260.881)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(43.677 4.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M4893.035,3266.388a20.826,20.826,0,1,0-3.349.613A10.61,10.61,0,0,0,4893.035,3266.388Z",
    transform: "translate(-4886.283 -3266.289)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(4706.863 2894.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(114.049 26.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M5087.028,3084.172l21.153-7.124.83,2.72s-8.264,13.029-17.9,15.715Z",
    transform: "translate(-5087.028 -3077.048)",
    fill: "#f26149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M4892.393,3073.949s32.661-22.922,34.62-23.614,15.975-.723,19.485-.348,13.567-.657,13.567-.657l-10.369-28.748,22.02-5.65-1.165-3.921s-17.711-10.634-27.951-7.6-15.036,16.475-17.167,19.8-6.737,15.215-28.608,29.2l-12.93,8.637Z",
    transform: "translate(-4883.896 -3002.865)",
    fill: "#f26149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(55.12 24.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M4950.607,3073.388c0,.01.044.121.131.327.1.235.228.531.385.9l1.465,3.391c1.28,2.934,3.1,7.106,5.336,12.235l.207-.292a29.686,29.686,0,0,0-3.748-.042,10.616,10.616,0,0,0-3.98.828c-2.436,1.374-4.821,3.041-7.373,4.748-5.07,3.445-10.545,7.281-16.25,11.323a4.932,4.932,0,0,1-2.383,1.146,3.964,3.964,0,0,1-3.167-6.9c.643-.508,1.4-1.009,2.077-1.506l4.086-2.916,14.12-10.112a11.646,11.646,0,0,0,2.522-2.514c.692-.882,1.289-1.75,1.839-2.566,1.094-1.637,1.967-3.088,2.668-4.28s1.222-2.132,1.567-2.773l.384-.734a1.672,1.672,0,0,0,.112-.26,1.291,1.291,0,0,0-.162.233l-.431.707-1.655,2.717c-.729,1.173-1.627,2.6-2.74,4.217-.559.8-1.165,1.659-1.859,2.521a11.357,11.357,0,0,1-2.475,2.415l-14.188,10.014-4.1,2.9c-.7.51-1.395.96-2.124,1.533a4.509,4.509,0,0,0,3.6,7.854,5.482,5.482,0,0,0,2.628-1.242c5.7-4.039,11.168-7.885,16.22-11.347,2.531-1.708,4.943-3.406,7.3-4.753a10.267,10.267,0,0,1,3.792-.806,29.7,29.7,0,0,1,3.687.011l.351.022-.145-.313c-2.365-5.149-4.29-9.338-5.642-12.285l-1.526-3.29-.394-.841A2.112,2.112,0,0,0,4950.607,3073.388Z",
    transform: "translate(-4919.335 -3073.386)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(0 52.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M4764.091,3197.023h0a9.63,9.63,0,0,0,13.721,2.425l43.58-34.026-7.738-13.171-47.067,31.547A9.631,9.631,0,0,0,4764.091,3197.023Z",
    transform: "translate(-4762.478 -3152.25)",
    fill: "#f26149"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(96.077 22.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(1.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M5039.368,3068.141l3.926,12.249,7.188.037-4.463-12.251Z",
    transform: "translate(-5039.368 -3068.141)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(2.215 8.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M5052.77,3094.269c0-.307-2.365-.568-5.288-.583s-5.292.221-5.293.528,2.366.568,5.288.583S5052.769,3094.575,5052.77,3094.269Z",
    transform: "translate(-5042.189 -3093.684)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    transform: "translate(0.848 5.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M5048.88,3083.141c0-.307-2.367-.568-5.288-.583s-5.292.221-5.294.528,2.366.568,5.288.583S5048.878,3083.448,5048.88,3083.141Z",
    transform: "translate(-5038.298 -3082.557)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(0 1.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M5046.466,3072.515c0-.307-2.366-.568-5.288-.583s-5.292.221-5.294.528,2.365.568,5.288.584S5046.465,3072.822,5046.466,3072.515Z",
    transform: "translate(-5035.885 -3071.932)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(113.914 31.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M5086.667,3093.409a26.685,26.685,0,0,0,1.747,6.378,34.248,34.248,0,0,0,2.611,6.074,46.461,46.461,0,0,0-2.088-6.263C5087.692,3096.184,5086.816,3093.371,5086.667,3093.409Z",
    transform: "translate(-5086.646 -3093.409)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M4700.764,3126.78c-.1-8.049,8.517-23.908,8.517-23.908l15.448,9.719-2.5,6.565,34.573,14.226,9.463.434,6.069,8.666-7.766,7.13-20.295-5.6C4731.44,3141.829,4700.878,3135.7,4700.764,3126.78Z",
    transform: "translate(-15.587 -173.209)",
    fill: "#ffc19d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(295.432 210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 47.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M398.085,653.428v33.365a42.8,42.8,0,0,0,42.8,42.8h0a42.8,42.8,0,0,0,42.8-42.8V653.428Z",
    transform: "translate(-397.605 -652.948)",
    fill: "#ccf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M439.164,728.353a43.333,43.333,0,0,1-43.284-43.284V651.7a.48.48,0,0,1,.48-.48h85.607a.48.48,0,0,1,.48.48v33.365A43.333,43.333,0,0,1,439.164,728.353Zm-42.323-76.168v32.885a42.323,42.323,0,0,0,84.647,0V652.184Z",
    transform: "translate(-395.88 -651.224)",
    fill: "#363e44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M494.185,474.226a.48.48,0,0,1-.48-.48,37.608,37.608,0,0,0-75.216,0,.48.48,0,0,1-.961,0,38.569,38.569,0,1,1,77.137,0A.48.48,0,0,1,494.185,474.226Z",
    transform: "translate(-412.813 -435.177)",
    fill: "#363e44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M528.552,755.153,511.19,739.368l5.364-6.611,11.008,8.8,17.273-25.071,7.028,4.837Z",
    transform: "translate(-486.074 -655.21)",
    fill: "#f26149"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "hy_300x47_1_",
    "data-name": "hy_300x47 (1)",
    width: 179,
    height: 28,
    transform: "translate(25 23)",
    fill: "url(#pattern)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordDesktop);
export default __webpack_public_path__ + "static/media/reset-password-desktop.93ee2c6fb19fa75c960707056d4d177a.svg";
export { ForwardRef as ReactComponent };